import React from 'react';
import { useNavigate } from 'react-router-dom';
import './QuickActionButton.css';

const QuickActionButton = ({ icon, label, path, color = 'primary', href }) => {
  const navigate = useNavigate();

  if (href) {
    return (
      <a
        className={`quick-action-btn quick-action-${color}`}
        href={href}
        download
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className={`fas ${icon}`}></i>
        <span>{label}</span>
      </a>
    );
  }

  return (
    <button
      className={`quick-action-btn quick-action-${color}`}
      onClick={() => navigate(path)}
    >
      <i className={`fas ${icon}`}></i>
      <span>{label}</span>
    </button>
  );
};

export default QuickActionButton;
